export const UPDATE_HOVER_STATE = 'UPDATE_HOVER_STATE';

export function updateHoverState(id, hoverState) {
  return {
    type: UPDATE_HOVER_STATE,
    payload: {id, hoverState}
  };
}



// WEBPACK FOOTER //
// ./app/features/lessonDetail/actions/updateHoverState.js